import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import SelectField, { mapOptionsToSelectField } from '../../../../shared-components/SelectField/SelectField';
import _ from 'lodash';

const LOCALE_PREFIX = 'GB/components/Address/Address';

export class State extends Component {
    static propTypes = {
        intl: intlShape.isRequired,

        // Plain k/v object with key:option value and value:display text mapping
        countyListOptions: PropTypes.object,
        ariadescribedby: PropTypes.string,
        idPrefix: PropTypes.string
    };

    render() {
        const { intl, idPrefix, countyListOptions, ariadescribedby } = this.props;

        return (
            <Field
                id={idPrefix ? `${idPrefix}-state` : 'state'}
                name="state"
                component={SelectField}
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.county`})}
                placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.county`})}
                optionList={mapOptionsToSelectField(countyListOptions)}
                ariadescribedby={ariadescribedby}
            />
        );
    }
}

export const mapStateToProps = state => ({
    // Grab the properties directly from the message object
    countyListOptions: _.get(state, `serverData.messages.${LOCALE_PREFIX}.countyListOptions`)
});

export default connect(mapStateToProps)(injectIntl(State));
